__turbopack_context__.v({
  "arrow": "WLanguageVersions-module__4MP3na__arrow",
  "dropdown": "WLanguageVersions-module__4MP3na__dropdown",
  "empty": "WLanguageVersions-module__4MP3na__empty",
  "flag": "WLanguageVersions-module__4MP3na__flag",
  "link": "WLanguageVersions-module__4MP3na__link",
  "linkActive": "WLanguageVersions-module__4MP3na__linkActive",
  "list": "WLanguageVersions-module__4MP3na__list",
  "menu": "WLanguageVersions-module__4MP3na__menu",
  "menuLink": "WLanguageVersions-module__4MP3na__menuLink",
  "name": "WLanguageVersions-module__4MP3na__name",
  "trigger": "WLanguageVersions-module__4MP3na__trigger",
  "triggerFlag": "WLanguageVersions-module__4MP3na__triggerFlag",
});
